import { gql } from '@apollo/client'

export const REQUEST_HELP = gql`
  mutation requestHelp($input: RequestHelperInput!) {
    requestHelp(input: $input) {
      message
    }
  }
`

export const FETCH_WORKSPACES = gql`
  query myWorkspaces {
    myWorkspaces {
      _id
      name
    }
  }
`

export const FETCH_CARD = gql`
  query myWork {
    currentWorkspace {
      name
      workspace
      crm
      company
      phone
      email
      thumb
    }
  }
`

export const UPDATE_WORKSPACE = gql`
  mutation up($input: AccountWorkspaceInput!) {
    updateAccountWorkspace(input: $input) {
      message
    }
  }
`

export const UPDATE_IOL = gql`
  mutation update($id: ID!, $input: AppIolLibraryCustomInput!) {
    iolLibrariesCustomUpdate(id: $id, input: $input) {
      message
      data {
        name
        enable
      }
    }
  }
`
export const UPDATE_CATARACT_TYPE = gql`
  mutation update($id: ID!, $input: AppCataractTypeCustomInput!) {
    cataractTypesCustomUpdate(id: $id, input: $input) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const UPDATE_IOL_TYPE = gql`
  mutation update($id: ID!, $input: AppIolTypeCustomInput!) {
    iolTypesCustomUpdate(id: $id, input: $input) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const UPDATE_ANATOMY_EYE_TYPE = gql`
  mutation update($id: ID!, $input: AppAnatomyEyesCustomInput!) {
    anatomyEyesCustomUpdate(id: $id, input: $input) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const REMOVE_IOL_CUSTOMIZATIONS = gql`
  mutation remove($id: ID!) {
    iolLibrariesCustomRemove(id: $id) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const REMOVE_CATARACT_TYPE_CUSTOMIZATIONS = gql`
  mutation remove($id: ID!) {
    cataractTypesCustomRemove(id: $id) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const REMOVE_IOL_TYPE_CUSTOMIZATIONS = gql`
  mutation remove($id: ID!) {
    iolTypesCustomRemove(id: $id) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const REMOVE_ANATOMY_EYE_CUSTOMIZATIONS = gql`
  mutation remove($id: ID!) {
    anatomyEyesCustomRemove(id: $id) {
      message
      data {
        name
        enable
      }
    }
  }
`

export const FETCH_ALL = gql`
  query GlobalState {
    iolTypes {
      name
      id
      enable
      internalAnnotations
      position
      thumb
      slug
      cacheKey
      simulation {
        after
        before
      }
      timestamp {
        unix
        format(format: "DD/MM/Y")
      }
    }
    iolLibraries {
      name
      thumb
      slug
      cacheKey
      iframe
      enable
      id
      position
      iolType
      internalAnnotations
      timestamp {
        unix
        format(format: "DD/MM/Y")
      }
      price {
        float
        format(after: "R$ ")
      }
      properties {
        items {
          key
          name
          hasProperty
        }
        graphics {
          key
          name
          value
        }
        satisfaction {
          key
          name
          value
        }
      }
    }
    cataractTypes {
      name
      id
      enable
      internalAnnotations
      position
      thumb
      slug
      cacheKey
      iframe
      timestamp {
        unix
        format(format: "DD/MM/Y")
      }
      simulations {
        thumb
        progress
      }
    }
    anatomyEye {
      id
      enable
      internalAnnotations
      name
      thumb
      slug
      cacheKey
      iframe
      timestamp {
        unix
        format(format: "DD/MM/Y")
      }
    }
    scenes {
      name
      thumb
      slug
      cacheKey
      timestamp {
        unix
        format(format: "DD/MM/Y")
      }
    }
    helpers {
      id
      name
      description
      thumb
      movie
      slug
      cacheKey
      timestamp {
        unix
        format(format: "DD/MM/Y")
      }
    }
  }
`

export const FETCH_PROCEDURES = gql`
  query getProcedures {
    procedures(params: { perPage: 1000 }) {
      edges {
        id
        name
        totalPrice {
          float
          format
        }
        items {
          name
          price {
            float
          }
        }
      }
    }
  }
`

export const FETCH_PROCEDURE = gql`
  query getProcedures($id: ID) {
    procedures(params: { ids: [$id] }) {
      edges {
        id
        name
        internalAnnotations
        enable
        totalPrice {
          float
        }
        items {
          name
          code
          price {
            float
          }
        }
      }
    }
  }
`

export const CREATE_PROCEDURE = gql`
  mutation createProcedure($input: ProcedureCreateInput!) {
    createProcedures(rows: [$input]) {
      message
      edges {
        id
        name
        items {
          name
          price {
            format
          }
        }
      }
    }
  }
`

export const UPDATE_PROCEDURE = gql`
  mutation updateProcedure(
    $filter: ProcedureFilterInput!
    $input: ProcedureUpdateDataInput!
  ) {
    updateProcedures(filter: $filter, input: $input) {
      message
      edges {
        id
        name
        items {
          name
          price {
            format
          }
        }
      }
    }
  }
`

export const CREATE_ORDER_MUTATION = gql`
  mutation createOrder($input: OrderCreateInput!) {
    createOrder(input: $input) {
      message
      edges {
        id
        numberOs
      }
    }
  }
`

export const LIST_ORDERS = gql`
  query searchOrder($params: OrderSearchInput) {
    orders(params: $params) {
      edges {
        numberOs
        id
        cart {
          name
          ref
          code
          price
        }
        iol {
          typeId
          typeName
          iolId
          iolName
          price
        }
        createdAt {
          format(format: "DD/MM/Y HH:mm")
        }
        status
        payment {
          netAmount
          discount
        }
        customer {
          name
          cpf
          email
          phone
          annotations
        }
        annotations
      }
    }
  }
`

export const REMOVE_ORDER = gql`
  mutation removeOrder($filter: OrderFilterInput!) {
    removeOrders(filter: $filter) {
      message
    }
  }
`

export const UPDATE_ORDER = gql`
  mutation updateOrder(
    $filter: OrderFilterInput!
    $input: OrderUpdateDataInput!
  ) {
    updateOrders(filter: $filter, input: $input) {
      message
    }
  }
`
